// ページ内リンク
document.querySelectorAll('a[href^="#"]').forEach(link => {
    link.addEventListener("click", e => {
        const target = document.querySelector(link.getAttribute("href"));
        if (!target) return;

        e.preventDefault();
        target.scrollIntoView({
            behavior: "smooth",
            block: "start"
        });
    });
});

// imgの拡大
document.querySelectorAll('.zoom-item').forEach(img => {

    img.addEventListener('click', e => {

        // 拡大中なら閉じる
        if (img.classList.contains('is-zoom')) {
            img.classList.remove('is-zoom');
            img.style.transformOrigin = 'center center';
            return;
        }

        // 他を閉じる
        document.querySelectorAll('.zoom-img.is-zoom').forEach(item => {
            item.classList.remove('is-zoom');
            item.style.transformOrigin = 'center center';
        });

        const rect = img.getBoundingClientRect();

        const x = ((e.clientX - rect.left) / rect.width) * 100;
        const y = ((e.clientY - rect.top) / rect.height) * 100;

        img.style.transformOrigin = `${x}% ${y}%`;
        img.classList.add('is-zoom');

    });

});